module.exports = __webpack_public_path__ + "img/infoImg3.db56d7ec.png";